export const liveTickerTemporary = {
  "id": "live-ticker-temporary-rugby-deutschland-2025",
  "title": "Live-Ticker vorübergehend nur auf Rugby-Deutschland verfügbar",
  "slug": "live-ticker-vorubergehend-rugby-deutschland",
  "publishedAt": "2025-09-03T10:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "3 min",
  "tags": ["Rugby", "Bundesliga", "Live-Ticker", "Website", "Rugby-Deutschland"],
  "excerpt": "Der Live-Ticker für Bundesligaspiele ist aktuell nur über Rugby-Deutschland verfügbar. Wir arbeiten an der Integration auf unserer eigenen Website.",
  "img": "/images/live-ticker-temporary-2025.jpg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Auf unserer neuen Website möchten wir euch künftig alle wichtigen Informationen zu den Bundesligaspielen gebündelt und übersichtlich präsentieren. Der Live-Ticker mit den aktuellen Spielständen und Statistiken ist ein zentraler Bestandteil davon. Leider ist diese Funktion zum jetzigen Zeitpunkt noch nicht eingebaut."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Überganglösung über Rugby Deutschland"
    },
    {
      "type": "paragraph",
      "content": "Damit ihr dennoch keine Begegnung verpasst, könnt ihr den bewährten Live-Ticker wie gewohnt direkt auf der Seite von Rugby Deutschland nutzen. Dort findet ihr alle laufenden Partien der 1. und 2. Bundesliga in Echtzeit:"
    },
    {
      "type": "list",
      "items": [
        { "content": "1. Bundesliga", "url": "https://www.rugbydeutschland.org/1-bundesliga-384878v4/leagues/12215/seasons/218" },
        { "content": "2. Bundesliga Nord/Ost", "url": "https://www.rugbydeutschland.org/2-bundesliga-nord-ost-384879v4/leagues/2162/seasons/218" },
        { "content": "2. Bundesliga Süd/West", "url": "https://www.rugbydeutschland.org/2-bundesliga-sud-west-384880v4/leagues/2161/seasons/218" }
      ]
    },
    {
      "type": "paragraph",
      "content": "Wir arbeiten mit Hochdruck daran, den Live-Ticker auch auf unserer eigenen Seite zu integrieren und euch damit einen noch besseren Service zu bieten. Bis dahin danken wir euch für euer Verständnis und wünschen viel Freude beim Verfolgen der Spiele."
    }
  ]
};
